import React, { lazy, Suspense } from 'react';
import { Container } from 'js/ui/legacy';
import { withTranslation } from 'react-i18next';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { selectors as userSelectors } from '../../redux/reducers/User';
import pricingActions from 'js/redux/reducers/Pricing';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TopBar, TopBarLeft } from 'js/components/layout/Containers';
import _ from 'lodash';
import { offline_mode } from '../../Constants';
import { rightToLeft } from '../../mylib/Utils';
import { navigateBack } from 'js/redux/Router';

const ConfigTree = lazy(() => import('./ConfigTree'));

class ConfigPage extends React.Component {
  state = {
    modalOpen: false,
    modalOpenOnce: false,
    originalDriverConfig: null,
    originalEnableAutomaticDispensers: null,
    modalOpenFromBack: false,
  };

  componentDidMount() {
    if (
      this.props.privileges &&
      !this.props.privileges.includes('tools_and_settings')
    ) {
      this.props.navigateTo('/');
    } else {
      this.props.fetchPricingBundle();
    }
    this.setState({
      originalDriverConfig: this.props.machine.driver_config,
      originalEnableAutomaticDispensers:
        this.props.configurations?.config?.enable_automatic_dispensers?.value,
    });
  }

  handleCloseModal = () => {
    this.setState({
      modalOpen: false,
    });
    if (this.state.modalOpenFromBack) {
      this.props.navigateBack();
    }
  };

  handleOpenModal = () => {
    if (
      this.state.originalDriverConfig !== this.props.machine.driver_config ||
      this.state.originalEnableAutomaticDispensers !==
        this.props.configurations?.config?.enable_automatic_dispensers?.value
    ) {
      this.setState({
        modalOpen: true,
        modalOpenFromBack: false,
        // modalOpenOnce: true,
        originalDriverConfig: this.props.machine.driver_config,
        originalEnableAutomaticDispensers:
          this.props.configurations?.config?.enable_automatic_dispensers?.value,
      });
    }
  };
  goBack = () => {
    if (
      !_.isEqual(
        this.state.originalDriverConfig,
        this.props.machine.driver_config
      ) ||
      !_.isEqual(
        this.state.originalEnableAutomaticDispensers,
        this.props.configurations?.config?.enable_automatic_dispensers?.value
      )
    ) {
      if (!this.state.modalOpenOnce) {
        this.setState({
          modalOpen: true,
          modalOpenOnce: true,
          modalOpenFromBack: true,
        });
      } else {
        this.props.navigateBack();
      }
    } else {
      this.props.navigateBack();
    }
  };

  render() {
    const isRtl = rightToLeft();
    const { configPath, navigateTo, t } = this.props;
    const setConfigPath = (path) => {
      navigateTo(path ? `/config/${encodeURIComponent(path)}` : '/config', {
        replace: true,
      });
    };

    return (
      <div className={'zoom-in'}>
        {offline_mode && (
          <div className="offline_info_text_right">
            {t(
              'msg.offlineChangesWillBeLost',
              'Changes will be lost when returning online mode'
            )}
          </div>
        )}
        <TopBar>
          <TopBarLeft>
            <h2
              data-testid={'back'}
              className="clickable-text directly-over-bg mt-8"
              onClick={this.goBack}
            >
              <FontAwesomeIcon
                icon={isRtl ? 'arrow-right' : 'arrow-left'}
                style={{ fontSize: '1.7rem' }}
              />{' '}
              {t('fn.toolsAndSettings', 'Tools and Settings')}
            </h2>
          </TopBarLeft>
        </TopBar>
        <Container className="justify-content-center">
          <Suspense fallback={null}>
            <ConfigTree
              configPath={configPath}
              setConfigPath={setConfigPath}
              originalDriverConfig={this.state.originalDriverConfig}
              originalEnableAutomaticDispensers={
                this.state.originalEnableAutomaticDispensers
              }
              handleCloseModal={this.handleCloseModal}
              handleOpenModal={this.handleOpenModal}
              modalOpen={this.state.modalOpen}
            />
          </Suspense>
        </Container>
      </div>
    );
  }
}

ConfigPage.propTypes = {
  t: PropTypes.func.isRequired,
  configPath: PropTypes.string,
  navigateTo: PropTypes.func.isRequired,
  navigateBack: PropTypes.func.isRequired,
  privileges: PropTypes.array,
  machine: PropTypes.object,
  configurations: PropTypes.shape({
    config: PropTypes.object,
  }),
  fetchPricingBundle: PropTypes.func,
};

const mapStateToProps = (state) => ({
  privileges: userSelectors.privileges(state),
  configurations: state.configurations,
  machine: state.machine,
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      fetchPricingBundle: pricingActions.fetchPricingBundle,
      navigateBack,
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation('translations')(ConfigPage));
